<template>
  <div class="row">
    <div class="hidden-xs hidden-sm">
      <div class="web-phone-tab">
        <div class="web-tab-center spaceBetween">
          <div class="web-center-left start">
            <img src="@/images/logo1.png" alt="#" class="web-left-img" @click="goGoodFood" />
            <div class="web-left-line"></div>
            <img src="@/images/logo2.png" alt="#" class="web-left-img" @click="goIndex" />
          </div>

          <div class="web-center-right end">
            <div class="web-right-font" :class="{'choiceFont':type==1}" @click="choiceType(1)">中文</div>
            <div class="web-right-line"></div>
            <div class="web-right-font" :class="{'choiceFont':type==2}" @click="choiceType(2)">EN</div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden-md hidden-lg">
      <div class="phone-tab spaceBetween">
        <div class="phone-tab-left start" @click="goIndex">
          <img src="@/images/logo1.png" alt="#" class="phone-left-img" @click="goGoodFood"/>
          <div class="phone-left-line"></div>
          <img src="@/images/logo2.png" alt="#" class="phone-left-img" @click="goIndex"/>
        </div>

        <div class="phone-center-right end">
          <div class="phone-right-font" :class="{'choiceFont':type==1}" @click="choiceType(1)">中文</div>
          <div class="phone-right-line"></div>
          <div class="phone-right-font" :class="{'choiceFont':type==2}" @click="choiceType(2)">EN</div>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>
export default {
  name: 'tab',
  data () {
    return {
      type:1
    }
  },
  methods:{
    goGoodFood(){
      const vm=this
      window.open('http://www.goodfoodchina.net/');
    },
    goIndex(){
      const vm=this
      vm.$router.push({path: '/index'});
    },
    choiceType(num){
      const vm=this
      vm.type=Number(num)
      localStorage.setItem("ssType", num);
      vm.$parent.choiceType(vm.type)
    }
  },
  created () {
    const vm = this;
    if(localStorage.getItem('ssType')){
      vm.$parent.choiceType(localStorage.getItem('ssType'))
    }
  },
}
</script>

<style scoped>
.row{
  margin: 0;
  padding: 0;
}
.web-phone-tab{
  width: 100%;
  height: 0.625rem;
  background: #fff;
}
.web-tab-center{
  padding: 0 0.25rem;
  height: 100%;
}
.web-center-left{
  width: auto;
  height: 100%;
}
.web-left-img{
  width: auto;
  height: 100%;
  cursor: pointer;
}
.web-left-line{
  width: 1px;
  height: 0.375rem;
  background: #ccb992;
}
.web-right-font{
  font-size: 0.1125rem;
  line-height: 1;
  color: #a5af9a;
  font-family: "Times New Roman", Times, serif;
  cursor: pointer;
}
.web-right-line{
  width: 1px;
  height: 18px;
  background: #a5af9a;
  margin: 0 0.1rem;
}

/**  移动端  **/
.phone-tab{
  padding: 0 0.2rem;
  height: 1.2rem;
}
.phone-tab-left{
  width: auto;
  height: 100%;
}
.phone-left-img{
  width: auto;
  height: 100%;
}
.phone-left-line{
  width: 1px;
  height: 0.8rem;
  background: #ccb992;
}
.phone-right-font{
  font-size: 0.24rem;
  line-height: 1;
  color: #a5af9a;
  font-family: "Times New Roman", Times, serif;
}
.phone-right-line{
  width: 1px;
  height: 0.4rem;
  background: #ccb992;
  margin: 0 0.4rem;
}
.choiceFont{
  color: #406343;
}
</style>
